module.exports = [{
      plugin: require('/home/katlin/Coding/portfolio/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
